import { render, staticRenderFns } from "./ShopSummarySupply.vue?vue&type=template&id=5c6a42fd&scoped=true"
import script from "./ShopSummarySupply.vue?vue&type=script&lang=js"
export * from "./ShopSummarySupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a42fd",
  null
  
)

export default component.exports